module.exports = __webpack_public_path__ + "static/media/canpar.02aa4b8e.svg";